import { Flex, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { OpeningHours } from "../../data/outlets.api";

type Props = {
  openingHours: OpeningHours;
};

const OpeningHoursTable = ({ openingHours }: Props) => {
  return (
    <Stack spacing={1}>
      {openingHours.daysOfWeek.map((openingHour) => (
        <Flex key={openingHour.day} justify="space-between" alignItems="center">
          <Text fontWeight="bold">{openingHour.day}</Text>
          <Text>
            {openingHour.closed
              ? "Closed"
              : `${openingHour.openFrom} - ${openingHour.openTo}`}
          </Text>
        </Flex>
      ))}
    </Stack>
  );
};

export default OpeningHoursTable;
